@if (!isLoading && uiService.isCaseViewMinimized) {
  <div matTooltip="Expand Case View" (click)="uiService.isCaseViewMinimized = !uiService.isCaseViewMinimized"
    class="case-view-collapsed" data-cy="case-view-collapsed">
    <div style="display: flex; flex-direction: column;" data-cy="case-view-collapsed-container">
      <lucide-icon name="chevron-right" [size]="20" data-cy="case-view-collapsed-chevron"></lucide-icon>
      <div style="color: var(--tdo-primary-accent);" data-cy="case-view-collapsed-icon"><lucide-icon name="clipboard" [size]="20"></lucide-icon></div>
      <div style="transform: rotate(-90deg); font-size: 10px; line-height: 1; font-weight: 500;" data-cy="case-view-collapsed-text">CASE VIEW</div>
    </div>
  </div>
}
@if (!uiService.isCaseViewMinimized) {
  <div
    style="width: 332px; display: flex; flex-direction: column; height: 100%;" data-cy="case-view-expanded">
    <div style="flex-basis: 56px; min-height: 56px; display: flex; flex-direction: column;" data-cy="case-view-header">
      <div style="display: flex; flex-basis: fit-content;" data-cy="case-view-title-bar">
        <div style="cursor: pointer; position: relative; right: 0; color: black; font-weight: 500;"
          (click)="uiService.isCaseViewMinimized = !uiService.isCaseViewMinimized" data-cy="case-view-collapse-btn">
          <lucide-icon name="chevron-left" [size]="20" matTooltip="Collapse Case View"></lucide-icon>
        </div>
        <div style="margin-left: 8px;"><b>Case View</b></div>
      </div>
      @if (isCanEdit()) {
        <div style="display: flex; margin-top: -8px; flex-direction: row; flex-wrap: nowrap; justify-content: space-between;" id="case-button-container" data-cy="case-view-actions">
          <button style="position: relative; top: 1px;" mat-icon-button color="primary" (click)="openDialogAddForm()"  matTooltip="Add Form"
            [disabled]="currentSectionSelection === 1 && !currentCaseWorkItemID" data-cy="case-view-add-form-btn">
            <lucide-icon name="file-text" [size]="20"></lucide-icon>
          </button>
          <button mat-icon-button color="primary" (click)="openDialogAddProcedure('ap')"
            [disabled]="currentSectionSelection === 0" data-cy="case-view-add-procedure-btn"
             matTooltip="Add Sub-Procedure">
            <lucide-icon name="stethoscope" [size]="20"></lucide-icon>
          </button>
          <button mat-icon-button color="primary" [disabled]="!this.allowToothPicker" (click)="openDialogEditTeeth()" data-cy="case-view-edit-teeth-btn"
           matTooltip="Edit Procedure Teeth">
            <img style="width:23px" src="assets/Images/Calendar/iconToothNew.svg">
          </button>
          <button [disabled]="!currentCaseWorkItemID && !currentCaseWorkItemFormID" mat-icon-button
            style="position: relative; top: 1px;" mat-icon-button color="primary"
            (click)="openDialogRemove()" data-cy="case-view-remove-btn"
            matTooltip="Remove">
            <lucide-icon name="x-circle" [size]="20"></lucide-icon>
          </button>
          <button mat-icon-button color="primary" (click)="onOpenVitalSigns($event)"
            matTooltip="Open Vital Signs" data-cy="case-view-vital-signs-btn">
            <img src="assets/icons/icons8_heart_with_pulse_2.svg"
              style="width: 20px; height: 20px;"
              alt="Heart Pulse">
            </button>
            <!--<button mat-icon-button style="color: var(--tdo-secondary);" (click)="openPerioCharting()">
            <lucide-icon name="line-chart" [size]="20" matTooltip="Perio Charting"></lucide-icon>
          </button>!-->
          <button mat-icon-button color="primary"
            style="position: relative; top: 1px; white-space: nowrap;" (click)="openMedicalHistory()" 
            [matTooltip]="patientMedicalAlerts.length > 0 ? 'Medical Record -ALERTS- Click to open' : 'Medical Record - Click to open'"
            data-cy="case-view-medical-history-btn">
            <lucide-icon name="clipboard-list" [size]="20" 
            [style.color]="patientMedicalAlerts.length > 0 ? 'var(--color-red)' : 'inherit'"
            ></lucide-icon>
            @if (patientMedicalAlerts.length > 0) {
              <lucide-icon name="bell-ring" [size]="20" 
              
              style="position: absolute; left: 18px; cursor: pointer; top: -4px; transform: scale(0.5, 0.5); color: var(--color-red);"
              ></lucide-icon>
            }
          </button>
          
          <button mat-icon-button color="primary"
            style="position: relative; top: 1px; white-space: nowrap;" (click)="isShowPatientForms = !isShowPatientForms" 
            data-cy="case-view-patient-icon" [matTooltip] = "isShowPatientForms ? 'Hide patient forms' : 'Show patient forms'">
              <lucide-icon name="user" 
              [size]="20"></lucide-icon>
              <lucide-icon [name]="isShowPatientForms ? 'eye' : 'eye-off'" [size]="20"
              style="position: absolute; left: 18px; cursor: pointer; top: -4px; transform: scale(0.5, 0.5); color: var(--tdo-secondary);"
              ></lucide-icon>
          </button>
          
          <button mat-icon-button color="primary"  matTooltip="More Options" id="link1" style="position: relative;" (click)="toggleMoreContent()" data-cy="case-view-more-options-btn">
            <lucide-icon name="more-vertical" [size]="20"></lucide-icon>
          </button>
          <dx-popover target="#case-button-container" position="right" [width]="300" [showTitle]="true" title="Case Actions"
            [(visible)]="showMoreCaseOptions" data-cy="case-view-more-options-popover">
            <div *dxTemplate="let data = model of 'content'" data-cy="case-view-more-options-content">
              <dx-list [dataSource]="listOfMoreCaseOptions" itemTemplate="listItem" data-cy="case-view-more-options-list">
                <div *dxTemplate="let caseOption of 'listItem'" (click)="processMoreOptionsEvent(caseOption.id)" data-cy="case-view-more-option-item">
                  {{ caseOption.name }}
                </div>
              </dx-list>
            </div>
          </dx-popover>
        </div>
      }
    </div>
    @if (hasCriticalMedicalAlerts) {
      <tdo-alert-banner
        type="critical"
        message="You have Medical Alerts to review."
        data-cy="case-view-premed-alert">
      </tdo-alert-banner>
    }
    @if (CaseInfo && CaseInfo.ReferringDoctorId && CaseInfo.ReferringDoctorId !== emptyGuid) {
      <div style="flex-basis: 20px;background-color: var(--tdo-primary-accent); color: white; padding-left: 10px; font-weight: 600; display: flex; align-items: center; justify-content: space-between;">
        <span style="white-space: nowrap;">Referring Dr. : <span class="referring-doctor-name" [matTooltip]="CaseInfo?.ReferringDoctorFirstName + ' ' + CaseInfo?.ReferringDoctorLastName">{{CaseInfo?.ReferringDoctorFirstName}} {{CaseInfo?.ReferringDoctorLastName}}</span></span>
        <button style="position: relative; top: 1px; height: fit-content; flex-shrink: 0;" mat-icon-button (click)="openReferringDoctorDetails()" data-cy="case-view-referring-doctor-details-btn" matTooltip="View Referring Doctor">
          <lucide-icon name="id-card" [size]="20" style="color: white;"></lucide-icon>
        </button>
      </div>
    }
    @if (isShowPatientForms) {
      <div style="flex-basis: 230px; overflow-y: auto;" data-cy="case-view-patient-forms-container">
        <!--PATIENT FORMS MAIN-->
        <div style="height: 100%; width: 100%; display: flex; flex-direction: column; overflow-y: hidden;"
          (click)="onPatientFormsSectionClick()"
          [ngClass]="{'section_highlight' : this.currentSectionSelection === 0, 'section_no_highlight' : this.currentSectionSelection === 1}"
          data-cy="case-view-patient-forms-section">
          <div
            style="width: 100%; flex-basis: fit-content; display: flex; position: relative; color: var(--tdo-secondary);" data-cy="case-view-patient-forms-header">
            <div class="header_item_cell" style="width: 60%;" data-cy="case-view-patient-forms-title">Patient Forms</div>
            <div class="header_item_cell item_cell_width_pct_15" data-cy="case-view-patient-forms-status-header">Status</div>
            <div class="header_item_cell item_cell_width_pct_25"></div>
            <div class="header_item_cell item_cell_width_pct_15" style="padding-right: 5px"></div>
            <div (click)="onPatientFormsDetails()"
              style="position: absolute; right: 5px; top: 9px; color: var(--tdo-secondary); cursor: pointer;" data-cy="case-view-patient-forms-details-btn">
              <lucide-icon name="file-text" [size]="20"></lucide-icon>
            </div>
          </div>
          @if (isLoadingPatientForms) {
            <mat-progress-bar mode="indeterminate" data-cy="case-view-patient-forms-loading"></mat-progress-bar>
          }
          @if (!isLoadingPatientForms && caseWorkItemsPatientForms.length <= 0) {
            <div style="width: 100%; text-align: center;" data-cy="case-view-patient-forms-empty">
              No general forms added.
            </div>
          }
          @if (!isLoadingPatientForms && caseWorkItemsPatientForms.length > 0) {
            <div style="overflow-y: auto; flex: 1; width: 100%;" data-cy="case-view-patient-forms-list">
              @for (form of caseWorkItemsPatientForms; track form; let f = $index) {
                <div data-cy="case-view-patient-form-item">
                  <div
                    (click)="onPatientFormClick(form);"
                    [ngClass]="{'form-selected' : this.isCurrentSelection('', form.CaseWorkItemFormsId)}" data-cy="case-view-patient-form-row">
                    <table style="width:100%" data-cy="case-view-patient-form-table">
                      <tr class="row_form" style="display: flex;">
                        <td class="item_cell cursorPointer" style="padding-left: 10px; width: 60%;" data-cy="case-view-patient-form-description">
                          <div>{{ form.Description }} {{ form.toothList ? '(#' + form.toothList + ')' : '' }}</div>
                        </td>
                        <td class="item_cell item_cell_width_pct_15 cursorPointer" style="margin-right: 5px; min-width:55px;" data-cy="case-view-patient-form-date">
                          {{ form.StatusOn | date:'shortDate' }}
                        </td>
                        <td class="item_cell item_cell_width_pct_25 cursorPointer" style="font-weight: 500; padding-left: 8px;" data-cy="case-view-patient-form-status">
                          {{ getFormEnumStatus(form.enumFormCompletionStatusID) }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (isShowPatientForms) {
      <div style="flex-basis: 8px;"></div>
    }
    <div style="flex: 1; overflow-y: hidden; display: flex; flex-direction: column;" data-cy="case-view-procedures-container">
      <div style="flex-basis: fit-content; display: flex; flex-direction: column; overflow-y: hidden;"
        (click)="this.currentSectionSelection = 1; this.currentCaseWorkItemFormID = null; this.currentCaseWorkItemID = null;"
        [ngClass]="{'section_highlight' : this.currentSectionSelection === 1, 'section_no_highlight' : this.currentSectionSelection === 0}"
        data-cy="case-view-procedures-header">
        <div style="width:100%; display: flex;" data-cy="case-view-procedures-header-row">
          @if (!CaseInfo || !CaseInfo.ProcedureName) {
            <div class="header_item_cell item_cell_width_pct_50" data-cy="case-view-procedures-title">Procedure / Forms</div>
          }
          @if (CaseInfo && CaseInfo.ProcedureName) {
            <div class="header_item_cell item_cell_width_pct_50" data-cy="case-view-procedures-title" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" matTooltip="{{CaseInfo?.ProcedureName}}">{{CaseInfo?.ProcedureName}}</div>
          }
          <div class="header_item_cell item_cell_width_pct_15" data-cy="case-view-procedures-teeth-header">Teeth</div>
          <div class="header_item_cell item_cell_width_pct_15" data-cy="case-view-procedures-date-header">Date</div>
          <div class="header_item_cell item_cell_width_pct_20" data-cy="case-view-procedures-status-header">Status</div>
        </div>
        @if (isLoading || isLoadingPatientForms) {
          <mat-progress-bar mode="indeterminate" data-cy="case-view-procedures-loading"></mat-progress-bar>
        }
      </div>
      @if (!isLoadingPatientForms && !isLoading) {
        <div style="flex: 1; overflow-y: auto;" data-cy="case-view-procedures-list">
          @for (caseWorkItem of caseWorkItems; track $index; let i = $index) {
            <div style="flex: 1;" data-cy="case-view-procedure-item">
              <div (click)="onClickCaseWorkItem(caseWorkItem);"
                [ngClass]="{'procedure-selected' : this.isCurrentSelection(caseWorkItem.CaseWorkItemId, ''), 'row-procedure': !this.isCurrentSelection(caseWorkItem.CaseWorkItemId, '')}"
                data-cy="case-view-procedure-row">
                <table style="width:100%; padding:0px; margin:0px" data-cy="case-view-procedure-table">
                  <tr style="background-color: unset;">
                    <td class="item_cell item_cell_width_pct_50"
                      style="font-weight: bold; padding-bottom: 0px !important; margin-bottom: 0px !important;" data-cy="case-view-procedure-description">{{
                    caseWorkItem.Description }}</td>
                    <td class="item_cell item_cell_width_pct_15" data-cy="case-view-procedure-teeth">{{ this.returnToothList(caseWorkItem.dataPatientCaseItemTeeth) }}
                    </td>
                    <td class="item_cell item_cell_width_pct_15" data-cy="case-view-procedure-date">{{ caseWorkItem.StatusOn | date:'shortDate' }}</td>
                    <td class="item_cell item_cell_width_pct_20" data-cy="case-view-procedure-status">
                      <div style="width: 100%; text-align: center; margin-top: 6px;">
                        <tdo-status-dot
                          [status]="getCaseStatusDot(caseWorkItem.enumCaseWorkItemStatusID)"
                          [tooltip]="returnCaseStatusIcon(caseWorkItem.enumCaseWorkItemStatusID, 0)"
                          data-cy="case-view-procedure-status-dot">
                        </tdo-status-dot>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4" class="item_cell" style="padding-top: 0px !important; margin-top: 0px !important;" data-cy="case-view-procedure-controls">
                      <div style="display: flex; align-items: center; justify-content: center; height:25px" data-cy="case-view-procedure-timer-container">
                        <div style="flex-basis: 50px" data-cy="case-view-procedure-timer-buttons">
                          @if (!caseWorkItem.EventDateStart && isCanEdit()) {
                            <button [style]="'width: 30px;height:35px'"
                              mat-icon-button matTooltip="Start Timer"
                              (click)="timerAction(caseWorkItem.WorkItemEventID, caseWorkItem.CaseWorkItemId, caseWorkItem.LOCID, true, false)"
                              data-cy="case-view-procedure-start-timer">
                              <lucide-icon name="circle-play" [size]="20" style="color:green"></lucide-icon>
                            </button>
                          }
                          @if (caseWorkItem.EventDateStart && isCanEdit()) {
                            <button [style]="'width: 30px;height:35px'"
                              mat-icon-button matTooltip="Stop Timer"
                              (click)="timerAction(caseWorkItem.WorkItemEventID, caseWorkItem.CaseWorkItemId, caseWorkItem.LOCID, false, true)"
                              data-cy="case-view-procedure-stop-timer">
                              <lucide-icon name="circle-stop" [size]="20" style="color:red"></lucide-icon>
                            </button>
                          }
                        </div>
                        <div style="flex: 1; height: 26px;" data-cy="case-view-procedure-doctor-container">
                          <div
                            style="padding: 1px 4px 6px 4px; width: 260px; height: 100%; border-radius: 6px; border: 1px solid var(--tdo-secondary-accent); background-color: white;"
                            data-cy="case-view-procedure-doctor-dropdown-container">
                            @if (activeLocationDoctors && activeLocationDoctors.length < 1) {
                              <label data-cy="case-view-procedure-no-doctors">No Location Doctors Found.</label>
                            }
                            @if (activeLocationDoctors.length > 0 && isCanEdit()) {
                              <tdo-dropdown-v2 [datasource]="getDoctorDropdownOptions(caseWorkItem)" isHideUnderline="true"
                                [value]="caseWorkItem.ProviderDoctor"
                                displayProperty="FullName" placeholder="Doctor" placeholderPosition="below"
                                [isPreventMouseEventPropagation]="true"
                                [disabledPredicate]="doctorDisabledPredicate"
                                (selectionChange)="timerDoctorAction(caseWorkItem.WorkItemEventID, caseWorkItem.CaseWorkItemId, $event)" class="case-dropdown"
                                data-cy="case-view-procedure-doctor-dropdown"
                                [hideSingleSelectionIndicator]="true">
                              </tdo-dropdown-v2>
                            }
                          </div>
                        </div>
                        <div (click)="onShowAllEventsForWorkItem(caseWorkItem)" matTooltip="See all events for this item."
                          style="flex-basis: fit-content; color: var(--tdo-secondary-accent); margin-left: 2px; cursor: pointer;"
                          data-cy="case-view-procedure-events-btn">
                          <lucide-icon name="more-horizontal" [size]="20"></lucide-icon>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              @for (form of caseWorkItem.dataPatientCaseItemForms; track form; let f = $index) {
                <div data-cy="case-view-form-item">
                  <div (click)="onFormItemClick(form, caseWorkItem);"
                    [ngClass]="{'item-selected' : this.isCurrentSelection('', form.CaseWorkItemFormsId)}" data-cy="patient-case-form" style="cursor: pointer;">
                    <table style="width:100%" data-cy="case-view-form-table">
                      <tr class="row_form">
                        <td class="item_cell form_item_cell item_cell_width_pct_50" style="padding-left: 10px" data-cy="case-view-form-description-cell">
                          <table style="width:100%;" data-cy="case-view-form-inner-table">
                            <tr>
                              <td style="width:10%;" data-cy="case-view-form-icon-cell">
                                <span style="position: relative; left: -10px;"
                                  matTooltip="{{form.formFilledTooltip}}" data-cy="case-view-form-icon">
                                  @if (form?.formFilledIcon != '') {
                                    <img alt="Filled By" style="width:20px;" src="assets/Images/Calendar/{{form.formFilledIcon}}">
                                  }
                                </span>
                              </td>
                              <td data-cy="case-view-form-description">{{ form.Description }}</td>
                            </tr>
                          </table>
                        </td>
                        <td class="item_cell item_cell_width_pct_15" data-cy="case-view-form-teeth">{{form.toothList || ''}}</td>
                        <td class="item_cell item_cell_width_pct_15" data-cy="case-view-form-date">{{ form.StatusOn | date:'shortDate' }}</td>
                        <td class="item_cell item_cell_width_pct_20" data-cy="case-view-form-status">
                          <div style="text-align: center; margin-top: 2px;">
                            <tdo-status-dot
                              [status]="getFormStatusDot(form)"
                              [tooltip]="form.formCompletionStatusTooltip"
                              data-cy="case-view-form-status-dot">
                            </tdo-status-dot>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
}
